import { render, staticRenderFns } from "./chatbotDocumentsModal.vue?vue&type=template&id=3a452494&scoped=true&"
import script from "./chatbotDocumentsModal.vue?vue&type=script&lang=ts&"
export * from "./chatbotDocumentsModal.vue?vue&type=script&lang=ts&"
import style0 from "./chatbotDocumentsModal.vue?vue&type=style&index=0&id=3a452494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a452494",
  null
  
)

export default component.exports